export type SignReportType = 'existing-sign' | 'missing-sign'

export interface SignReport {
  reportType: SignReportType
  title: string
  reporter: string
  datasource: string
  mapLink?: string | null
  signType: string
  speedLimit: number | null
  displayType: string
  supplementarySigns: string[]
  category: string
  description: string
  // sign-details only
  signId: string | null
  occurrenceDateTime: string | null
  // map-location only
  location: { lat: number; lng: number } | null
  bearing: number | null
}

export function getDefaultSignReportTitle(
  report: Pick<SignReport, 'reportType' | 'signType'>,
): string {
  const reportKind = report.reportType === 'missing-sign' ? 'Missing sign' : 'Existing sign'

  return `${reportKind} - ${report.signType}`
}
